



























































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import OzButton from 'library/v4/components/OzButton.vue'

@Component({ components: { OzButton } })
export default class SurfacePostModeration extends Mixins() {
  @Prop({ required: true }) colorScheme!: 'light' | 'dark'
  @Getter isStream!: boolean

  deletePost(): void {
    this.$emit('delete')
  }
  approve(): void {
    this.$emit('approve')
  }
}
